import React from "react";
import { useSelector } from "react-redux";
import TheHeader from "./comm/TheHeader";
import {
  CFormGroup,
  CCol,
  CCardBody,
  CInputCheckbox,
  CLabel,
  CContainer,
} from "@coreui/react";
import TheNav from "./comm/TheNav";
import TheFooter from "./comm/TheFooter";
import PreviewPop from "./previewPop";
import Swal from "sweetalert";
import ApiHelper from "src/utils/api/api_helper";
import { useHistory, useLocation } from "react-router-dom";

const SubmissionPage = () => {
  const state = useSelector((state) => state);
  const { main, insert } = useSelector((state) => state);
  const history = useHistory();
  const [formList, setFormList] = React.useState([]);
  const [checkItems, setCheckItems] = React.useState([]);
  const [apoDocAllChkYn, setApoDocAllChkYn] = React.useState([]);
  const [inputCpnt, setInputCpnt] = React.useState([]);
  const singleCheck = document.getElementsByName("singleCheck");
  // const [lastCheckItems, setLastCheckItems] = React.useState([]);
  // const lastCheck = document.getElementById("lastCheck");
  const corpNm = useLocation().pathname.split('/')[1];
  const [previewPop, setPreviewPop] = React.useState({
    isOpen: false,
    form: null,
  });
  const chkAfcrList = state.apoDocForm.apoDocCnfmYn.filter((item) => item.cnfmYn).map((item) => item.afcrNo);

  const handleAllCheck = (checked) => {
    if(corpNm == 'onef'){
       Swal(""
        , `위촉계약서는 메일로 발송됩니다. \n " 보험사 위촉 서류 " 를 출력하셔서 해당 지점에
        서류를 제출 하셔야 위촉이 진행됩니다.`, "info").then(()=>{
          if (checked) {
            const idArray = [];
            singleCheck.forEach((item) => {
              idArray.push(item.value);
            });
            setCheckItems(idArray);
          } else {
            setCheckItems([]);
          }
        });
    }else{
      if (checked) {
        const idArray = [];
        singleCheck.forEach((item) => {
          idArray.push(item.value);
        });
        setCheckItems(idArray);
      } else {
        setCheckItems([]);
      }
    }
   
    
  };

  const handleSingleCheck = (checked, value) => {
    if (checked) {
      setCheckItems([...checkItems, value]);
    } else {
      setCheckItems(checkItems.filter((item) => item !== value));
    }
  };

  // const handleLastCheck = (checked, value) => {
  //   if (checked) {
  //     setLastCheckItems([...lastCheckItems, value]);
  //   } else {
  //     setLastCheckItems(lastCheckItems.filter((item) => item !== value));
  //   }
  // };

  const handleSubmission = async () => {
    let extYn = false;

    // 입력정보 누락 방지
    if (inputCpnt.filter((item) => item.INPUT_COMP_CD === 'BR').length > 0 && insert.reqTaskInfo.brNo === "")
      return Swal("지점명", "지점명이 선택되지 않았습니다.\n이전 단계로 돌아가 선택 후 제출해주세요.", "info");
    if (inputCpnt.filter((item) => item.INPUT_COMP_CD === 'BASIC').length > 0 && insert.reqTaskInfo.resRegNoBack.trim().length < 7)
      return Swal("주민등록번호", "주민등록번호 뒷자리가 입력되지 않았습니다.\n이전 단계로 돌아가 입력 후 제출해주세요.", "info");
    if (inputCpnt.filter((item) => item.INPUT_COMP_CD === 'ADDR').length > 0 && insert.reqTaskInfo.addr.trim() === "")
      return Swal("주소", "주소가 입력되지 않았습니다.\n이전 단계로 돌아가 입력 후 제출해주세요.", "info");
    if (inputCpnt.filter((item) => item.INPUT_COMP_CD === 'EMAIL').length > 0) {
      if (insert.reqTaskInfo.emalAddr.trim() === "")
        return Swal("이메일주소", "이메일주소가 입력되지 않았습니다.\n이전 단계로 돌아가 입력 후 제출해주세요.", "info");
      if (insert.reqTaskInfo.emalDmn.trim() === "")
        return Swal("이메일도메인", "이메일도메인이 입력되지 않았습니다.\n이전 단계로 돌아가 입력 후 제출해주세요.", "info");
    }
    if (inputCpnt.filter((item) => item.INPUT_COMP_CD === 'BANK').length > 0) {
      if (insert.reqTaskInfo.bankCd === "")
        return Swal("은행명", "은행명이 입력되지 않았습니다.\n이전 단계로 돌아가 선택 후 제출해주세요.", "info");
      if (insert.reqTaskInfo.actNo.trim() === "")
        return Swal("계좌번호", "계좌번호가 입력되지 않았습니다.\n이전 단계로 돌아가 입력 후 제출해주세요.", "info");
    }
    if (inputCpnt.filter((item) => item.INPUT_COMP_CD === 'FAX').length > 0 && insert.reqTaskInfo.faxNo.trim() === "") {
      return Swal("팩스번호", "팩스번호가 입력되지 않았습니다.\n이전 단계로 돌아가 입력 후 제출해주세요.", "info");
    }
    if (inputCpnt.filter((item) => item.INPUT_COMP_CD === 'RECR').length > 0 && insert.reqTaskInfo.recrNm.trim() === ""  && !(main.corpNm == "LS-FC" || main.corpNm == "LS-EFA" )) {
       return Swal("도입자명", "도입자명 입력되지 않았습니다.\n이전 단계로 돌아가 입력 후 제출해주세요.", "info");
    }
    if (inputCpnt.filter((item) => item.INPUT_COMP_CD === 'EDU').length > 0 && insert.reqTaskInfo.eduLevel === "") {
      return Swal("학력", "학력이 입력되지 않았습니다.\n이전 단계로 돌아가 입력 후 제출해주세요.", "info");
   }
    await ApiHelper.request(
      ApiHelper.methods.post,
      "/cust/request/checkExtSbmsFiles",
      {
        reqNo: insert.reqTaskInfo.reqNo,
      }).then((res) => {
      return res.data;
      }).then((data) => {
        if (Number(data.data.CNT) === 0) {
          extYn = true;
          return extYn;
        } else{
          return Swal("추가제출서류", "필수로 제출해야 하는 추가제출서류가 정상적으로 등록되지 않았습니다.\n이전 단계로 돌아가 등록 후 제출해주세요.", "info");
        }
      })
      .catch((err) => {
        console.error(err);
      });

      if(extYn) {
        for (let item of singleCheck) {
          if (!item.checked)
            return Swal(
              "원본서류",
              `${item.dataset.title}가 체크되지 않았습니다.`,
              "error"
            );
        }
        
        // let _sbmsDocFiles = state.sbmsDoc.sbmsDocFiles.filter(
        //   (item) => item.ncryYn === "1"
        // );
    
        // for (let checkItem of _sbmsDocFiles) {
        //   if (checkItem.fileInfo.length <= 0) {
        //     return Swal(
        //       "추가서류",
        //       `${checkItem.docNm} 파일이 등록되지 않았습니다.`,
        //       "error"
        //     );
        //   }
        // }
    
        ApiHelper.request(
          ApiHelper.methods.post,
          "/cust/request/submission",
          {
            reqNo: insert.reqTaskInfo.reqNo,
            ifKey: corpNm,
          }
        )
          .then(({ data }) => {
            if (data.status === "SUCCESS") {
              history.push(`/${corpNm}/8`);
            }
          })
          .catch((err) => {
            console.error(err);
          });
      }
  };

  let params = {
    corpNo: main.corpNo,
    taskNo: main.taskNo,
  };

  React.useEffect(() => {

    // 사용자 입력 정보 유효성 체크를 위한 input 리스트 가져오기
    ApiHelper.request(
      ApiHelper.methods.post,
      "/cust/request/getInputCpnts",
      params
    )
    .then(({ data }) => {
      if (data.status === "SUCCESS") {
        let result = data.data;
        setInputCpnt(result);
      }
    })
    .catch((err) => {
      console.error(err);
    });
      


    ApiHelper.request(ApiHelper.methods.post, '/cust/request/apoDocAllChkYn', {
      params
    })
      .then(({ data }) => {
        if (data.status === 'SUCCESS') {
          const result = data.data;
          setApoDocAllChkYn(Number(result.APO_DOC_ALL_CHK_YN));
        }
      })
      .catch((err) => {
        console.error(err);
      });

    const setCorpFormList = async () => {
      await ApiHelper.request(
        ApiHelper.methods.post,
        "/cust/request/corpFormList",
        params
      )
        .then(({ data }) => {
          if (data.status === "SUCCESS") {
            if(apoDocAllChkYn){
              const result = data.data;
              let formList = [];

              formList = result.filter((item) => item.AFCR_NO === '' || chkAfcrList.indexOf(String(item.AFCR_NO)) > -1);
              setFormList(formList);
            } else {
              setFormList(data.data);
            }

            if (
              insert.reqTaskInfo.stCd !== "10" &&
              insert.reqTaskInfo.stCd !== "99"
            ) {
              handleAllCheck(true);
            }
          }
        })
        .catch((err) => {
          console.error(err);
        });
    };

    setCorpFormList();

    return () => setCheckItems([]);
  }, []);

  const handlePreviewClick = (e, form) => {
    const value = e.target.dataset.val;

    if (
      insert.reqTaskInfo.stCd === "10" ||
      insert.reqTaskInfo.stCd === "99"
    ) {
      if (checkItems.indexOf(value) === -1) {
        setCheckItems([...checkItems, value]);
      }
    }

    setPreviewPop({ isOpen: true, form: form });
  };

  return (
    <>
      <TheHeader />
      <div className="c-main">
        <TheNav step={main.step} />
        <CContainer className="text-left">
          <h5>
            <b>
              {main.cntrYn !== '0' && '위촉계약서 및 '}보험사별 위촉서류 최종원본을 확인합니다.
              <br></br>
              서류를 클릭하시면 해당 서류를 작성된 파일을 보실수 있으며, PDF로
              다운로드도 가능합니다.
            </b>
          </h5>
          {corpNm.toLowerCase() === 'global' && main.cntrYn !== '0' &&
          <span className="subSpan"><h6><b>
            상기 위촉계약서는 작성완료 직후, 본인의 이메일로 발송되며,
            GOMS에서 상시 열람 및 출력이 가능합니다.
          </b></h6></span>}
        </CContainer>
        <CCardBody className="bottom-card-body">
          <CFormGroup row>
            {/* <CCol xs="12" className="text-left useLine">
                <CFormGroup variant="checkbox" className="checkbox">
                  <CInputCheckbox
                    id="checkAll"
                    name="checkAll"
                    value="checkAll"
                    onChange={(e) => handleAllCheck(e.target.checked)}
                    checked={
                      checkItems.length === 0
                        ? false
                        : checkItems.length === singleCheck.length
                        ? true
                        : false
                    }
                  />
                  <CLabel
                    variant="checkbox"
                    className="form-check-label"
                    htmlFor="checkAll"
                  >
                    모두선택
                  </CLabel>
                </CFormGroup>
              </CCol> */}
            {formList.map((form, index) => {
              if (form.FORM_CAT_CD !== "20") return null;
              return (
                <CCol xs="12" className="text-left topSpace" key={index}>
                  <div className="component-checkbox submission-box">
                    <label>
                      <input 
                        type="checkbox" 
                        id="checkCntrDoc"
                        name="singleCheck"
                        value="checkCntrDoc"
                        data-title={"위촉계약서"}
                        onChange={(e) =>
                          handleSingleCheck(e.target.checked, e.target.value)
                        }
                        checked={
                          checkItems.includes("checkCntrDoc") ? true : false
                        }
                        disabled={
                          insert.reqTaskInfo.stCd !== "10" &&
                          insert.reqTaskInfo.stCd !== "99"
                            ? true
                            : false
                        }
                      />
                      <i />
                      <span className="txt-label">{form.FORM_NM}</span>
                    </label>
                    <CLabel
                      data-val="checkCntrDoc"
                      onClick={(e) => handlePreviewClick(e, form)}
                      className="showFile"
                    >
                      [보기]
                    </CLabel>
                  </div>
                  {/* <CInputCheckbox
                    id="checkCntrDoc"
                    name="singleCheck"
                    value="checkCntrDoc"
                    data-title={"위촉계약서"}
                    onChange={(e) =>
                      handleSingleCheck(e.target.checked, e.target.value)
                    }
                    checked={
                      checkItems.includes("checkCntrDoc") ? true : false
                    }
                    disabled={
                      state.insert.reqTaskInfo.stCd !== "10" &&
                      state.insert.reqTaskInfo.stCd !== "99"
                        ? true
                        : false
                    }
                  />
                  <CLabel
                    variant="checkbox"
                    className="form-check-label"
                    htmlFor="checkCntrDoc"
                  >
                    {form.FORM_NM}
                    <CLabel
                      data-val="checkCntrDoc"
                      onClick={(e) => handlePreviewClick(e, form)}
                      className="showFile"
                    >
                      [보기]
                    </CLabel>
                  </CLabel> */}
                </CCol>
              );
            })}
            <CCol xs="12">
              <CFormGroup row></CFormGroup>
            </CCol>
            <CCol xs="12" className="text-left">
              <div>
                <p>
                  <b>보험사별 위촉서류</b>
                </p>
              </div>
            </CCol>
            {formList.map((form, index) => {
              if (form.FORM_CAT_CD !== "10" && form.FORM_CAT_CD !== "30") return null;
              return (
                <CCol
                  xs={formList.length ? 12 : 6}
                  className="text-left mb-1 mt-1"
                  key={form.FORM_NO}
                >
                  <div className="component-checkbox submission-box">
                    <label>
                      <input 
                        type="checkbox" 
                        id={`checkForm${index + 1}`}
                        name="singleCheck"
                        value={`checkForm${index + 1}`}
                        data-title={form.FORM_NM}
                        onChange={(e) =>
                          handleSingleCheck(e.target.checked, e.target.value)
                        }
                        checked={
                          checkItems.includes(`checkForm${index + 1}`)
                            ? true
                            : false
                        }
                        disabled={
                          insert.reqTaskInfo.stCd !== "10" &&
                          insert.reqTaskInfo.stCd !== "99"
                            ? true
                            : false
                        }
                      />
                      <i />
                      <span className="txt-label">{form.FORM_NM}</span>
                    </label>
                    <CLabel
                      data-val={`checkForm${index + 1}`}
                      onClick={(e) => handlePreviewClick(e, form)}
                      className="showFile"
                    >
                      [보기/다운로드]
                    </CLabel>
                  </div>
                  {/* <CFormGroup variant="checkbox" className="checkbox">
                    <CInputCheckbox
                      id={`checkForm${index + 1}`}
                      name="singleCheck"
                      value={`checkForm${index + 1}`}
                      data-title={form.FORM_NM}
                      onChange={(e) =>
                        handleSingleCheck(e.target.checked, e.target.value)
                      }
                      checked={
                        checkItems.includes(`checkForm${index + 1}`)
                          ? true
                          : false
                      }
                      disabled={
                        state.insert.reqTaskInfo.stCd !== "10" &&
                        state.insert.reqTaskInfo.stCd !== "99"
                          ? true
                          : false
                      }
                    />
                    <CLabel
                      variant="checkbox"
                      className="form-check-label"
                      htmlFor={`checkForm${index + 1}`}
                    >
                      {form.FORM_NM}
                      <CLabel
                        data-val={`checkForm${index + 1}`}
                        onClick={(e) => handlePreviewClick(e, form)}
                        className="showFile"
                      >
                        [보기]
                      </CLabel>
                    </CLabel>
                  </CFormGroup> */}
                </CCol>
              )
            })}
            <CCol xs="12">
              <CFormGroup row></CFormGroup>
            </CCol>
            <CCol xs="12" className="text-left submission-all-confirm">
              <div className="component-checkbox submission-box">
                <label>
                  <input 
                    type="checkbox" 
                    id="checkAll"
                    name="checkAll"
                    value="checkAll"
                    onChange={(e) => handleAllCheck(e.target.checked)}
                    checked={
                      checkItems.length === 0
                        ? false
                        : checkItems.length === singleCheck.length
                        ? true
                        : false
                    }
                    disabled={
                      insert.reqTaskInfo.stCd !== "10" &&
                      insert.reqTaskInfo.stCd !== "99"
                        ? true
                        : false
                    }
                  />
                  <i />
                  <span className="txt-label">원본 서류의 내용을 모두 확인</span>
                </label>
              </div>
              {/* <CFormGroup variant="checkbox" className="checkbox">
                <CInputCheckbox
                  id="checkAll"
                  name="checkAll"
                  value="checkAll"
                  onChange={(e) => handleAllCheck(e.target.checked)}
                  checked={
                    checkItems.length === 0
                      ? false
                      : checkItems.length === singleCheck.length
                      ? true
                      : false
                  }
                  disabled={
                    state.insert.reqTaskInfo.stCd !== "10" &&
                    state.insert.reqTaskInfo.stCd !== "99"
                      ? true
                      : false
                  }
                />
                <CLabel
                  variant="checkbox"
                  className="form-check-label"
                  htmlFor="checkAll"
                >
                  <b>원본 서류의 내용을 모두 확인</b>
                </CLabel>
              </CFormGroup> */}
            </CCol>
          </CFormGroup>
        </CCardBody>
      </div>
      <TheFooter step={main.step} handleSubmission={handleSubmission} />
      {previewPop.isOpen && (
        <PreviewPop
          onClose={() => setPreviewPop({ isOpen: false })}
          form={previewPop.form}
        ></PreviewPop>
      )}
    </>
  );
};

export default SubmissionPage;
